import { Button, Group, Text } from '@mantine/core';

interface NumberPadProps {
  value: string;
  onChange: (value: string) => void;
  allowDecimal?: boolean;
  suffix?: string;
}

/**
 * Своя цифровая клавиатура вместо системной.
 * В перчатках по системной клавиатуре не попасть, а на iOS она ещё и
 * норовит зазумить страницу. Клавиши крупные и в нижней части экрана.
 */
export function NumberPad({
  value,
  onChange,
  allowDecimal = false,
  suffix,
}: NumberPadProps): React.JSX.Element {
  const press = (key: string): void => {
    if (key === '.' && (!allowDecimal || value.includes('.'))) return;
    if (key === '.' && value === '') {
      onChange('0.');
      return;
    }
    if (value.length >= 6) return;
    onChange(value + key);
  };

  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', allowDecimal ? '.' : '', '0', '⌫'];

  return (
    <div>
      <Group justify="center" mb="sm" gap="xs" align="baseline">
        <Text fz={48} fw={700} lh={1}>
          {value === '' ? '—' : value}
        </Text>
        {suffix !== undefined && (
          <Text fz="xl" c="dimmed">
            {suffix}
          </Text>
        )}
      </Group>

      <div className="pf-keypad">
        {keys.map((key, index) =>
          key === '' ? (
            <div key={`gap-${String(index)}`} />
          ) : (
            <Button
              key={key}
              variant={key === '⌫' ? 'light' : 'default'}
              onClick={() => {
                if (key === '⌫') onChange(value.slice(0, -1));
                else press(key);
              }}
            >
              {key}
            </Button>
          ),
        )}
      </div>
    </div>
  );
}
